<template>
  <div style="padding-top: 40px">
    <div>
      <div>
        <p class="navadno-besedilo">
          Ustvarite skupine kontaktov in v njih razvrstite svoje kontakte. Pošiljanje sporočil prejemnikom je tako še
          bolj preprosto: dodajte kar celo skupino.
        </p>
      </div>
      <div style="padding-top: 30px">
        <p class="open-sans-20pt">
          Nova skupina
        </p>
      </div>
      <div style="padding-top: 30px">
        <el-form label-width="160px" :label-position="formaOrientacija" class="nova-vrstica-forma">
          <el-form-item label="Naziv skupine">
            <el-input v-model="izbranaSkupinaZaDodajat.naziv" placeholder="Naziv skupine" class="velikost-input">
            </el-input>
          </el-form-item>
          <el-form-item label="Opis skupine">
            <el-input v-model="izbranaSkupinaZaDodajat.opis" resize="none" class="velikost-input"
                      :maxlength="100" show-word-limit
                      placeholder="Kratek opis">
            </el-input>
          </el-form-item>
          <el-form-item label="Izberi kontakte:">
            <el-select v-model="izbranaSkupinaZaDodajat.contacts" class="velikost-input" multiple allow-create>
              <el-option
                v-for="item in vsiKontakti"
                :key="item.idAddressBook"
                :label="item.mobile + ' ' + ' ' +item.ime + ' ' + item.priimek"
                :value="item.idAddressBook">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="padding-top: 30px">
          <el-button class="gumb-potrdi" type="primary" @click="DodajSkupino();">
            SHRANI SKUPINO
          </el-button>
        </div>
      </div>
    </div>
    <div style="padding-top: 40px">
      <hr class="hr-stil">
    </div>
    <div style="padding-top: 40px">
      <p class="open-sans-20pt">
        Seznam skupin
        <span class="odmik-iskanje-kontakta">
            <el-input v-model="isciPoPodatkihVSkupiniUredi" class="iskanje-kontakta" type="text"
                      placeholder="Poišči kontakt" prefix-icon="el-icon-search" id="iskanje">
            </el-input>
          </span>
      </p>
      <div v-if="typeof this.prikazaneSkupine !== 'undefined' && this.prikazaneSkupine.length > 0">
        <div style="padding-top: 20px; padding-bottom: 10px">
          <p class="navadno-besedilo">
            Označite skupine kontaktov, ki jih želite dodati med prejemnike sporočila.
          </p>
        </div>
        <div style="padding-top: 30px">
          <el-table
            :data="podseznamPrikazanihSkupin"
            :expand-row-keys="expandRowKeys"
            :row-key="row => row.naziv"
            @expand-change="ImenikSkupin"
            style="width: 100%">
            <el-table-column
              min-width="45"
              label="Izberite">
              <template slot-scope="scope">
                <input type="checkbox"
                       class="color-checkbox"
                       :value=scope.row
                       v-model="selectedGroups"
                       @change="SelectGroup(scope.row.idGroup)">
              </template>
            </el-table-column>
            <el-table-column
              min-width="55"
              prop="naziv"
              label="Naziv">
            </el-table-column>
            <el-table-column
              min-width="35"
              label="Opis">
              <template slot-scope="scope">
                <div v-if="scope.row.opis === 'undefined'">
                  /
                </div>
                <div v-else>
                  {{ scope.row.opis }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              min-width="45"
              label="Št. članov">
              <template slot-scope="scope">
                {{ scope.row.contacts.length }}
              </template>
            </el-table-column>
            <el-table-column
              label="" width="60px">
              <template slot-scope="scope">
                <a @click="IzbrisiSkupino(scope.row)" style="cursor: pointer">
                  <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                </a>
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding-top: 30px; padding-bottom: 30px">
                  <el-form label-width="160px" :label-position="formaOrientacija" class="nova-vrstica-forma">
                    <el-form-item label="Naziv skupine">
                      <el-input v-model="izbranaSkupinaZaUrejat.naziv" class="velikost-input" placeholder="Naziv skupine">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="Opis skupine">
                      <el-input v-model="izbranaSkupinaZaUrejat.opis" resize="none" class="velikost-input"
                                :maxlength="100" :rows="2" show-word-limit
                                placeholder="Kratek opis">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="Izberi kontakte:">
                      <template slot-scope="scope">
                        <el-select v-model="izbranaSkupinaZaUrejat.contacts" class="velikost-input" multiple allow-create>
                          <el-option
                            v-for="item in vsiKontakti"
                            :key="item.idAddressBook"
                            :label="item.mobile + ' ' + ' ' + item.ime + ' ' + item.priimek"
                            :value="item.idAddressBook">
                          </el-option>
                          <el-option
                              v-for="item in izbranaSkupinaZaUrejat.fullGroupContacts"
                              v-if="vsiKontakti.find(x => x.idAddressBook === item.idAddressBook) === undefined"
                              :key="item.idAddressBook"
                              :label="item.mobile + ' ' + ' ' + item.ime + ' ' + item.priimek"
                              :value="item.idAddressBook">
                          </el-option>
                        </el-select>
                        <el-tooltip class="item primarna-barva" effect="dark"
                                    content="Iskanje po osebah."
                                    placement="right">
                          <el-icon class="el-icon-info">
                          </el-icon>
                        </el-tooltip>
                      </template>
                    </el-form-item>
                  </el-form>
                  <div style="padding-top: 30px">
                    <el-button class="gumb-potrdi" @click="UrediSkupino();">
                      SHRANI SPREMEMBE
                    </el-button>
                    <a @click="PrekliciUrejanje" class="stil-gumb-preklici">
                      Prekliči
                    </a>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="text-center" style="cursor: pointer;">
          <br/>
          <el-pagination
            :hide-on-single-page="true"
            @current-change="PrikaziStranSkupin"
                :page-size="4"
          layout="prev, pager, next"
          :total="dolzinaSeznamaSkupin"
          small>
          </el-pagination>
        </div>
      </div>
      <div v-else>
        <div class="obvestilo-skupin">
          Brez ustvarjenih skupin.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Select, Option, Table, Button, Input, Tooltip, Collapse, CollapseItem, Dialog, MessageBox} from 'element-ui'
import {SirinaOkna} from '../../../../../assets/js/globalne_funkcije/SirinaOkna'

export default {
  name: 'ImenikSkupin',
  mixins: [SirinaOkna],
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Table.name]: Table,
    [Option.name]: Option,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Dialog.name]: Dialog,
    [MessageBox.name]: MessageBox
  },
  data () {
    return {
      izbranaSkupinaZaUrejat: {},
      izbranaSkupinaZaDodajat: {
        idGroup: 0,
        naziv: '',
        opis: '',
        contacts: []
      },
      formaOrientacija: 'left',
      mejnaSirina: 1400,
      activeName: '0',
      selectedGroups: [],
      prikazaneSkupine: [],
      title: 'Dodaj skupino',
      izbraniKontakti: [],
      idkontakta: [],
      dodajanjeIdKontakta: [],
      isciPoPodatkihVSkupiniUredi: '',
      urejanjeSkupine: {},
      expandRowKeys: [],
      nazivSkupineUrejanje: '',
      opisSkupineUrejanje: '',
      idSkupineUrejanje: '',
      dolzinaSeznamaSkupin: null,
      podseznamPrikazanihSkupin: [],
      noviSeznamGroups: []
    }
  },
  props: {
    izbranPosiljatelj: null,
    vseSkupine: null,
    vsiKontakti: null,
    selectedContacts: null,
    clientAgent: null,
    smsAuthentication: false
  },
  watch: {
    vseSkupine: function (data) {
      this.prikazaneSkupine = data.groups
      this.izbraniKontakti = this.selectedContacts
      if (typeof this.prikazaneSkupine !== 'undefined') {
        this.PreverjanjeSkupin()
      }
    },
    vsiKontakti: function () {
      this.isciPoPodatkihVSkupiniUredi = ''
    },
    isciPoPodatkihVSkupiniUredi: function (val) {
      if (val.length > 0 && typeof val !== 'undefined') {
        let podatki = this.vseSkupine.groups.filter(x => x.naziv.toLowerCase().includes(val.toLowerCase()) ||
          x.opis.toLowerCase().includes(val.toLowerCase()) ||
          x.naziv.concat(x.opis).toLowerCase().includes(val.replace(/\W/g, '').toLowerCase()))
        this.podseznamPrikazanihSkupin = podatki
      } else {
        this.podseznamPrikazanihSkupin = this.vseSkupine.groups
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.izbraniKontakti = this.selectedContacts
    this.prikazaneSkupine = this.vseSkupine.groups
    if (typeof this.prikazaneSkupine !== 'undefined') {
      this.PreverjanjeSkupin()
    }
  },
  methods: {
    PreverjanjeSkupin () {
      let tmpArray = []
      this.dolzinaSeznamaSkupin = this.prikazaneSkupine.length
      const chunk = 4
      for (let i = 0; i < this.dolzinaSeznamaSkupin; i += chunk) {
        tmpArray.push(this.prikazaneSkupine.slice(i, i + chunk))
      }
      this.prikazaneSkupine = tmpArray
      this.PrikaziStranSkupin(1)
    },
    PrikaziStranSkupin (stran) {
      if (typeof this.prikazaneSkupine[stran - 1] !== 'undefined') {
        this.podseznamPrikazanihSkupin = this.prikazaneSkupine[stran - 1]
      } else {
        this.podseznamPrikazanihSkupin = []
      }
    },
    ImenikSkupin (row, expandedRows) {
      const id = row.naziv
      const lastId = this.expandRowKeys[0]
      this.izbranaSkupinaZaUrejat = {}
      this.expandRowKeys = id === lastId ? [] : [id]
      if (expandedRows.length !== 0) {
        let contacts = []
        let fullGroupContacts = []
        for (let i = 0; i < row.contacts.length; i++) {
          contacts.push(row.contacts[i].idAddressBook)
          fullGroupContacts.push(row.contacts[i])
        }
        this.izbranaSkupinaZaUrejat = {
          idGroup: row.idGroup,
          naziv: row.naziv,
          opis: row.opis,
          contacts: contacts,
          fullGroupContacts: fullGroupContacts
        }
      }
    },
    PrekliciUrejanje () {
      this.title = 'Dodaj skupino'
      this.activeName = '0'
      this.izbranaSkupinaZaUrejat = {}
      this.idSkupineUrejanje = ''
      this.opisSkupineUrejanje = ''
      this.nazivSkupineUrejanje = ''
    },
    PreveriDodajanjeSkupine () {
      this.activeName = '1'
      if (this.vseSkupine.groups.length < 5 && typeof this.vseSkupine.groups.length !== 'undefined') {
      } else {
        this.SendErrorMsg('Dodanih je lahko največ 5 skupin kontaktov.')
      }
    },
    IzbrisiSkupino (podatkiSkupine) {
      MessageBox.confirm('Ste prepričani, da želite odstraniti skupino uporabnikov?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
        param.push(['idSkupina=' + podatkiSkupine.idGroup])
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/sms/imenik/izbrisiSkupino?',
          param,
          null,
          'SetIzbrisiSkupino',
          'ErrSprocilo')
      }).catch((err) => {
        err = null
      })
    },
    SetIzbrisiSkupino () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno izbrisana skupina.'
      this.ShowSuccessMessage(paramObvestilo)
      this.SendUpdateGroups()
    },
    UrediSkupino () {
      let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
      param.push('naziv=' + this.izbranaSkupinaZaUrejat.naziv)
      param.push('opis=' + this.izbranaSkupinaZaUrejat.opis)
      param.push('idSkupina=' + this.izbranaSkupinaZaUrejat.idGroup)
      for (let i = 0; i < this.izbranaSkupinaZaUrejat.contacts.length; i++) {
        param.push('idKontakt[]=' + this.izbranaSkupinaZaUrejat.contacts[i])
      }
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/sms/imenik/shraniSkupino?',
        param,
        null,
        'SetUrediSkupino',
        'SendErrorMsg')
    },
    SetUrediSkupino () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Skupina uspešno posodobljena.'
      this.ShowSuccessMessage(paramObvestilo)
      this.SendUpdateGroups()
      this.izbranaSkupinaZaUrejat = {}
      this.expandRowKeys = []
    },
    DodajSkupino () {
      let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
      param.push('naziv=' + this.izbranaSkupinaZaDodajat.naziv)
      param.push('opis=' + this.izbranaSkupinaZaDodajat.opis)
      param.push('idSkupina=' + this.izbranaSkupinaZaDodajat.idGroup)
      for (let i = 0; i < this.izbranaSkupinaZaDodajat.contacts.length; i++) {
        param.push('idKontakt[]=' + this.izbranaSkupinaZaDodajat.contacts[i])
      }
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/sms/imenik/shraniSkupino?',
        param,
        null,
        'SetDodajSkupino',
        'ErrSprocilo')
      this.InitDodajSkupinoSpremenljivko()
    },
    InitDodajSkupinoSpremenljivko () {
      this.izbranaSkupinaZaDodajat.naziv = ''
      this.izbranaSkupinaZaDodajat.opis = ''
      this.izbranaSkupinaZaDodajat.contacts = []
    },
    SetDodajSkupino () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno dodana skupina.'
      this.ShowSuccessMessage(paramObvestilo)
      this.SendUpdateGroups()
      this.izbranaSkupinaZaUrejat = {}
      this.$emit('updateGroups')
    },
    IzbrisiKontaktIzSkupine (idKontakt) {
      MessageBox.confirm('Ste prepričani, da želite odstraniti kontakt iz skupine?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
        param.push(['idSkupina[]=' + this.izbranaSkupinaZaUrejat.idGroup])
        param.push(['idKontakt=' + idKontakt])
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/sms/imenik/odstraniIzSkupine?',
          param,
          null,
          'SetIzbrisiKontaktIzSkupine',
          'ErrSprocilo')
      }).catch((err) => {
        err = null
      })
    },
    SetIzbrisiKontaktIzSkupine () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno izbrisan kontakt iz skupine.'
      this.ShowSuccessMessage(paramObvestilo)
      this.SendUpdateGroups()
    },
    SelectGroup (idGroup) {
      if (this.selectedGroups.length > 0 && !this.smsAuthentication) {
        let checkboxes = document.getElementsByClassName('color-checkbox')
        for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false
        }
        this.$emit('mfaIzklopljen')
        this.selectedGroups = []
      } else {
        if (this.noviSeznamGroups.includes(idGroup)) {
          for (let i = 0; i < this.noviSeznamGroups.length; i++) {
            if (this.noviSeznamGroups[i] === idGroup) {
              this.noviSeznamGroups.splice(i, 1)
            }
          }
        } else {
          this.noviSeznamGroups.push(idGroup)
          let paramObvestilo = {}
          paramObvestilo.message = 'Skupina uspešno dodana med prejemnike.'
          this.ShowSuccessMessage(paramObvestilo)
        }
        this.$emit('selectGroup', this.selectedGroups)
      }
    },
    SendUpdateGroups () {
      this.activeName = '0'
      this.$emit('updateGroups')
      this.$emit('updateKontakt')
    },
    ErrSprocilo (podatki) {
      this.SendUpdateGroups()
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/UporabniskiKoticek/PosljiSms/ImenikSkupin.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/PosljiSms/ImenikSkupin.vue